export default "__VITE_ASSET__JS9egcbI__"